export const semantic = {
  formField: {
    paddingX: '0.5rem',
    paddingY: '0.3rem',
  },
  colorScheme: {
    light: {
      formField: {
        filledBackground: '#ffffff',
        filledHoverBackground: '#ffffff',
        filledFocusBackground: '#ffffff',
        disabledBackground: '#ffffff',
      },
    },
  },
  overlay: {
    popover: {
      shadow:
        '/* bottom */ 0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.1),' +
        '/* top    */ 0 -4px 6px -1px rgba(0,0,0,0.1), 0 -2px 4px -2px rgba(0,0,0,0.1)',
    },
  },
};
